import { render, staticRenderFns } from "./ListMenu.vue?vue&type=template&id=0d0745cf&scoped=true"
import script from "./ListMenu.vue?vue&type=script&lang=ts"
export * from "./ListMenu.vue?vue&type=script&lang=ts"
import style0 from "./ListMenu.vue?vue&type=style&index=0&id=0d0745cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0745cf",
  null
  
)

export default component.exports